export default __webpack_public_path__ + "84c31088e85070a9c55653ae6fd9ebf5.svg";